import { Component, OnInit, AfterViewInit, EventEmitter, Output, ElementRef, ViewChild, HostListener } from '@angular/core';
import { LabelDesignService } from 'src/app/services/label-design.service';
import { PrintService } from 'src/app/services/print.service';
import { UserService } from 'src/app/services/user.service';
import { HubService } from 'src/app/services/Hub.service';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpEventType } from '@angular/common/http';
import { InterfaceUtils } from 'src/app/utils/interface.util';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-qz-tray-steps',
  templateUrl: './qz-tray-steps.component.html',
  standalone: false
})
export class QzTrayStepsComponent implements OnInit, AfterViewInit {

    qzUrlString = "";
    javaUrlString = "";
    isSystemplatform: string = "";
    @Output() CloseModal = new EventEmitter<any>();
    isQzLatestInstalled : boolean;
    currentVersion: string = '';
    downloadProgress: number = 0;
    isDownloading: boolean = false;
    downloadComplete: boolean = false;
    currentUserId: string;
    clearCookiesCalled = false;
    fromMainScreen: boolean = false;
    canclose = false;
    @Output() canCloseWindow =  new EventEmitter<boolean>();
    @Output() emitSSOFlag = new EventEmitter<any>();
    qzTrayPopup!: ElementRef;

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKey(event: KeyboardEvent): void { 
        this.Cancel(); 
    }

    constructor(
        private _printService: PrintService, 
        private _labeDesign: LabelDesignService,
        private _userService: UserService,
        private _hubService: HubService,
        private _commonServ: CommonService,
        private _router: Router,
        private _interfaceUtil: InterfaceUtils,
        private _storageService: StorageService
    ) { }

    ngOnInit() {
        
        this.isSystemplatform   = window.navigator.platform;;
        if(this.isSystemplatform  && (this.isSystemplatform  === 'Mac68K' || this.isSystemplatform  === 'MacPPC' || this.isSystemplatform  === 'MacIntel')) {
            this.qzUrlString =  environment.QzDownloadLinkForMac;
            this.javaUrlString = environment.JavaDownloadLinkforMac;
        } else {
            this.qzUrlString =  environment.QzDownloadLink;
            this.javaUrlString = environment.JavaDownloadLink;
        };
        this.isQzLatestInstalled = this._printService.isQzLatestVersion;
        this.currentVersion = this._printService.getCurrentQzVersion();
        this.currentUserId = this._userService.getToken("UserId");
     }

    getOS(): 'windows' | 'mac' | 'other' {
        const ua = navigator.userAgent;
        const platform = navigator.platform;

        if (ua.includes('Windows') || platform.includes('Win')) {
            return 'windows';
        }
        if (ua.includes('Mac') || platform.includes('Mac')) {
            return 'mac';
        }
        return 'other';
    }

    getArch(): 'x86' | 'arm64' {
        const ua = navigator.userAgent.toLowerCase();
        const platform = navigator.platform.toLowerCase();
        const navAny = navigator as any;
        if (navAny.userAgentData?.architecture === 'arm64') {
            return 'arm64';
        }
        if (platform.includes('arm') || ua.includes('arm') || ua.includes('aarch64')) {
            return 'arm64';
        }
        return 'x86';
    }

    downloadAndInstallNow(value? : string) {
        const os = this.getOS();
        const arch = this.getArch();
        const payload = {
            "os": os,    
            "architecture": arch
        };
        
        this.isDownloading = true;
        this.downloadProgress = 0;
        this.downloadComplete = false;
        if (!this.fromMainScreen) {
            document.querySelector('.modal-footer')?.classList.add('d-none');
        }
        this._labeDesign.getQzTryVersionWithProgress(payload).subscribe({
            next: (event) => {
                if (event.type === HttpEventType.DownloadProgress) { 
                    if (event.total) {
                        this.downloadProgress = Math.round((event.loaded / event.total) * 100);
                    }
                } else if (event.type === HttpEventType.Response) { 
                    this.downloadProgress = 100;
                    this.isDownloading = false;
                    this.downloadComplete = true;
                    this.fromMainScreen = value === 'FrmUpdate' ? true : false;
                    const blob = event.body as Blob;
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    
                    let filename = 'qz-tray';
                    if (os === 'windows') {
                        filename = 'qz-tray.exe';
                    } else if (os === 'mac') {
                        filename = 'qz-tray.pkg';
                    }
                    
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    if (this.downloadComplete && !this.isDownloading) {
                        const footer = document.querySelector('.modal-footer');
                        if (footer) {
                            footer.classList.remove('d-none');
                        }
                    }

                }
            },
            error: (err) => {
                this.isDownloading = false;
                this.downloadProgress = 0;
            }
        });
    }
    
    clickActions(value: string) {
        this.fromMainScreen = value === 'FrmMain' ? true : false;
        this.downloadAndInstallNow();
        /*javaLink.click();
        setTimeout(() => {
            QzLink.click();
        }, 10000);*/
    }
    clickQzLatestVersionActions(QzLink)
    {
        QzLink.click();
    }

    Cancel() {
        this.CloseModal.emit(null);
    }

    logout() {
        this._hubService.RemoveFromGroup();
        if (this.currentUserId) {
            this._userService.Logout(this.currentUserId).subscribe(
                (resp: any) => {
                    this.handleClearSession();
                },
                (err) => {
                    this.handleClearSession();
                }
            );
        } else {
            this.handleClearSession();
        }
    }

    handleClearSession() {
        if(this.clearCookiesCalled) {
            return;
        }
        this.clearCookiesCalled = true;
        const res = document.cookie;
        const multiple = res.split(";");
        for (let i = 0; i < multiple.length; i++) {
            const key = multiple[i].split("=");
            document.cookie =
                "" +
                key[0] +
                "=; expires= Thu, 21 Aug 1970 20:00:00 UTC; path=/ ";
        }
        let SfaxEncryptionVector = this._commonServ.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
        let printSet = localStorage.getItem("DefaultLabelPrinter");
        let reportPrint = localStorage.getItem("DefaultReportPrinter");
        let sso = this._commonServ.DecryptData(localStorage.getItem("SSO"));
        let IsImmediateModeKey = localStorage.getItem("ImmediateOrPopMode") ? this._commonServ.getDecryptLocalStorage("ImmediateOrPopMode", false, SfaxEncryptionVector) : null;
        let guidKey = localStorage.getItem("GUIDEyecon") ? this._commonServ.getDecryptLocalStorage("GUIDEyecon", false, SfaxEncryptionVector) : null;
        let EyeconIP = localStorage.getItem("EyeconIP") ? this._commonServ.getDecryptLocalStorage("EyeconIP", false, SfaxEncryptionVector) : null;
        let popModeAssigned = localStorage.getItem("popModeAssigned") ? this._commonServ.getDecryptLocalStorage("popModeAssigned", false, SfaxEncryptionVector) : null;
        let redirectUrl = localStorage.getItem("redirectUrl");
        const storedValue = this._storageService.get("IvrGUIDDetails");
        let ivrGuid = this._commonServ.getIvrGUIDDetails(storedValue, SfaxEncryptionVector);
        localStorage.clear();
        localStorage.removeItem("userLogged");
        localStorage.removeItem("tokenExpiryTime");
        if (printSet) {
            localStorage.setItem("DefaultLabelPrinter", printSet);
        }
        if (reportPrint) {
            localStorage.setItem("DefaultReportPrinter", reportPrint);
        }
        this._interfaceUtil.setPillCounterLocalStorage(SfaxEncryptionVector, IsImmediateModeKey, guidKey, EyeconIP, popModeAssigned);
        if (ivrGuid) {
            this._storageService.set("IvrGUIDDetails", ivrGuid);
        }
        sessionStorage.clear();
        this.canclose = true;
        if (!sso) {
            this.canCloseWindow.emit(true);
            window.close();
            window.close();
        }
        else {
            if (redirectUrl) {
                this.emitSSOFlag.emit(sso);
                window.close();
                window.onbeforeunload = null;
                window.location.href = redirectUrl;
            } else {
                this._router.navigate(["/login"]);
            }
        }
    }
    ngAfterViewInit() {
        /*setTimeout(() => {
            document
                .querySelector('.modal-footer')
                ?.classList.add('d-none'); 
        }, 500); */
    }

}
